import { render, staticRenderFns } from "./DecisionTree.vue?vue&type=template&id=34f315ca&"
import script from "./DecisionTree.vue?vue&type=script&lang=js&"
export * from "./DecisionTree.vue?vue&type=script&lang=js&"
import style0 from "./DecisionTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports